import React from 'react';

const PersonalTabSkeleton: React.FC = () => {
  return (
    <div className="max-w-7xl px-4 sm:px-6 md:px-0 animate-fadePulse">
      <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-3">
        <div>
          <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-3/4 mb-3"></div>
          <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
          <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-4/5 mt-2"></div>
        </div>

        <div className="md:col-span-2 p-6 bg-white rounded-lg border border-gray-200 dark:border-gray-700 dark:bg-gray-800">
          {/* Header with profile picture */}
          <div className="mb-6 flex items-center space-x-6 pb-6 border-b border-gray-200 dark:border-gray-700">
            <div className="flex-shrink-0">
              <div className="h-20 w-20 bg-gray-300 dark:bg-gray-700 rounded-full"></div>
            </div>
            <div className="flex-grow">
              <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded w-1/2 mb-2"></div>
              <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/3 mb-2"></div>
              <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-2/5"></div>
            </div>
          </div>

          {/* Basic Information Section */}
          <div className="mb-8">
            <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-1/4 mb-4"></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/3 mb-2"></div>
                <div className="h-10 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
              </div>
              <div>
                <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/3 mb-2"></div>
                <div className="h-10 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
              </div>
            </div>
          </div>

          {/* Professional Details Section */}
          <div className="mb-8">
            <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-1/4 mb-4"></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {[1, 2, 3, 4].map((i) => (
                <div key={i}>
                  <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/3 mb-2"></div>
                  <div className="h-10 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
                </div>
              ))}
            </div>
          </div>

          {/* Professional Summary Section */}
          <div className="mb-8">
            <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-1/4 mb-4"></div>
            <div>
              <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/3 mb-2"></div>
              <div className="h-24 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
            </div>
          </div>

          {/* Skills & Expertise Section */}
          <div className="mb-8">
            <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-1/4 mb-4"></div>
            <div className="space-y-4">
              {[1, 2, 3].map((i) => (
                <div key={i}>
                  <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/3 mb-2"></div>
                  <div className="h-10 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
                </div>
              ))}
            </div>
          </div>

          {/* Documents & Links Section */}
          <div className="mb-8">
            <div className="h-5 bg-gray-300 dark:bg-gray-700 rounded w-1/4 mb-4"></div>
            <div>
              <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/3 mb-2"></div>
              <div className="h-10 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
            </div>
          </div>

          {/* Last Updated Info */}
          <div className="flex items-center gap-2 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg mb-6">
            <div className="h-5 w-5 bg-gray-300 dark:bg-gray-600 rounded"></div>
            <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/3"></div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4 justify-end pt-6 border-t border-gray-200 dark:border-gray-700">
            <div className="h-10 bg-gray-300 dark:bg-gray-700 rounded w-24"></div>
            <div className="h-10 bg-gray-300 dark:bg-gray-700 rounded w-28"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalTabSkeleton;
